// Nome exibido para um usuário: `display_name` (pendências), senão `last_name`
// (onde a Pós guarda o nome completo), senão o `username`.
export const userLabel = user => (
  user ? user.display_name || user.last_name || user.username : ''
);

export default userLabel;
